// src/translations/pages/impressum/de.js
import { injectPersonalData } from './impressumUtils.js';

const baseTranslationDE = {
  title: 'Impressum',
  subtitle: 'Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz)',
  
  serviceProvider: 'Diensteanbieter',
  
  contactTitle: 'Kontakt',
  addressLabel: 'Anschrift',
  contactLabel: 'E-Mail-Adresse',
  
  professionalTitle: 'Angaben zum Unternehmen',
  professionLabel: 'Rechtsform',
  businessTypeLabel: 'Art der Tätigkeit',
  
  taxTitle: 'Steuerliche Angaben',
  
  liabilityTitle: 'Haftungshinweis',
  contentLiabilityTitle: 'Haftung für Inhalte',
  contentLiability: 'Als Diensteanbieter sind wir gemäß § 7 Abs.1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht unter der Verpflichtung, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.',
  
  linkLiabilityTitle: 'Haftung für Links',
  linkLiability: 'Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.',
  
  copyrightTitle: 'Urheberrecht',
  copyright: 'Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.'
};

// Export the translation with injected personal data
export const impressumPageDE = injectPersonalData('de', baseTranslationDE);